(ns estate-and-tax.views
  (:require
    [reagent.core :as r]
    [very.re-frame.core :as rf]
    [main.common :as common]
    [profile.common :as pc]
    [css.core :refer [defstyled get-theme] :as css]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [css.form :as form]
    [util.core :refer [long-str to-input-date to-local-time]]))

(defstyled form-section-header-s :div
  {:border-bottom (str "2px solid " (get-theme :primary))
   :padding-bottom "15px"
   :margin-bottom "30px"})

(defstyled form-section-title-s :h2
  {:font-size "24px"})

(defstyled form-section-description-s :div
  {:color vars/gray})

(defstyled radio-grid-s :div
  {:margin-bottom "30px"
   :margin-top "-15px"
   :display "grid"
   :grid-template-columns "max-content min-content min-content"
   :grid-column-gap "30px"})

(defstyled radio-question-s :p
  {:margin "0 0 30px"
   :color vars/gray})

(defstyled radio-label-s :div
  {:grid-column (with-meta identity :grid-column)
   :margin-bottom "5px"})

(defn manage [{:keys [on-save on-cancel cancel-label] :or {cancel-label "Cancel"}}]
  #_{:estate {:field :val
              :radio-field {:val-a true
                            :val-b false
                            :val-c false}}
     :taxes {:field :val}}
  (let [sub (rf/subscribe [:profile/estate-and-tax])
        tmp @sub
        f (atom nil)

        doc-group-id (str (random-uuid))
        disclosure-group-id (str (random-uuid))
        submit-group-id (str (random-uuid))

        ;; take a map of {id -> dom-input} and extract the values from the dom nodes
        extract-field-values (fn [f kw]
                               (reduce (fn [m k] (assoc m k (.-value (get-in f [kw k]))))
                                       {}
                                       (keys (get f kw))))
        gather (fn [e]
                 (.preventDefault e)
                 ;; gather the unnested keys, then the radios separately
                 (let [estate (extract-field-values @f :estate)
                       ;; great band
                       estate-radios (assoc estate
                                            :documents-submitted (true? (.-checked (get-in @f [:estate :documents-submitted :yes])))
                                            :disclosure-submitted (true? (.-checked (get-in @f [:estate :disclosure-submitted :yes]))))

                       tax (extract-field-values @f :tax)
                       tax-radios (assoc tax
                                         :documents-submitted (true? (.-checked (get-in @f [:tax :documents-submitted :yes]))))]
                   (on-save {:estate estate-radios
                             :tax tax-radios})))]
    (fn []
      [common/form-s {:on-submit gather}
       [common/form-header-s
        [common/form-title-s {:margin "45px 0 0"} "Estate & tax planning"]
        [common/form-explain-s "Estate and tax planning services focus on protecting and maximizing the wealth you've already accumulated. Considering them as part of your overall financial plan provides the opportunity for potential savings and makes sure you're protected in the future."]]
       [pc/form-section-s
        [form-section-header-s
         [form-section-title-s "Estate"]]
        [form-section-description-s "Please provide information on your current will and/or trust and relevant contact."]
        [form/input-row-s {:margin "30px 0"}
         [form/input-label-s "Attorney's name"]
         [form/input {:type "text"
                      :label? true
                      :max-width "500px"
                      :required true
                      :default-value (get-in tmp [:estate :attorney])
                      :ref #(swap! f assoc-in [:estate :attorney] %)}]]
        [form/input-row-s
         [form/input-label-s "Successor trustee's name"]
         [form/input {:type "text"
                      :label? true
                      :max-width "500px"
                      :required true
                      :default-value (get-in tmp [:estate :successor])
                      :ref #(swap! f assoc-in [:estate :successor] %)}]]
        [form/input-row-s
         [form/input-label-s "Creation date for documents"]
         [form/past-date {:label? true
                          :required true
                          :ref #(swap! f assoc-in [:estate :documents-created] %)
                          :default-value (to-input-date (get-in tmp [:estate :documents-created]))}]]
        [radio-grid-s
         [radio-label-s {:grid-column 2} "Yes"]
         [radio-label-s {:grid-column 3} "No"]
         [radio-question-s "Have you submitted documents to your advisor?"]
         [:input {:type "radio"
                  :default-checked (true? (get-in tmp [:estate :documents-submitted]))
                  :ref #(swap! f assoc-in [:estate :documents-submitted :yes] %)
                  :required true
                  :name doc-group-id}]
         [:input {:type "radio"
                  :default-checked (false? (get-in tmp [:estate :documents-submitted]))
                  :ref #(swap! f assoc-in [:estate :documents-submitted :no] %)
                  :required true
                  :name doc-group-id}]
         [radio-question-s "Do you want us to contact your CPA, estate attorney, etc on your behalf?"]
         [:input {:type "radio"
                  :default-checked (true? (get-in tmp [:estate :disclosure-submitted]))
                  :ref #(swap! f assoc-in [:estate :disclosure-submitted :yes] %)
                  :required true
                  :name disclosure-group-id}]
         [:input {:type "radio"
                  :default-checked (false? (get-in tmp [:estate :disclosure-submitted]))
                  :ref #(swap! f assoc-in [:estate :disclosure-submitted :no] %)
                  :required true
                  :name disclosure-group-id}]]]

       [pc/form-section-s
        [form-section-header-s
         [form-section-title-s "Taxes"]]
        [form-section-description-s "Please include your CPA's name and your date of most recent tax return."]
        [form/input-row-s {:margin "30px 0"}
         [form/input-label-s "CPA's name"]
         [form/input {:type "text"
                      :label? true
                      :max-width "500px"
                      :required true
                      :default-value (get-in tmp [:tax :accountant])
                      :ref #(swap! f assoc-in [:tax :accountant] %)}]]
        [form/input-row-s {:percent? true
                           :grid-template-columns "6rem"}
         [form/input-label-s "Current tax rate"]
         [form/input {:type "number"
                      :label? true
                      :min 0
                      :max 100
                      :step 0.01
                      :required true
                      :default-value (get-in tmp [:tax :tax-rate])
                      :ref #(swap! f assoc-in [:tax :tax-rate] %)}]]
        [form/input-row-s
         [form/input-label-s "Date of most recent return"]
         [form/past-date {:label? true
                          :required true
                          :default-value (to-input-date (get-in tmp [:tax :most-recent-return]))
                          :ref #(swap! f assoc-in [:tax :most-recent-return] %)}]]
        [radio-grid-s
         [radio-label-s {:grid-column 2} "Yes"]
         [radio-label-s {:grid-column 3} "No"]
         [radio-question-s "Have you submitted documents to your advisor?"]
         [:input {:type "radio"
                  :default-checked (true? (get-in tmp [:tax :documents-submitted]))
                  :required true
                  :ref #(swap! f assoc-in [:tax :documents-submitted :yes] %)
                  :name submit-group-id}]
         [:input {:type "radio"
                  :default-checked (false? (get-in tmp [:tax :documents-submitted]))
                  :required true
                  :ref #(swap! f assoc-in [:tax :documents-submitted :no] %)
                  :name submit-group-id}]]]
       [form/button-row-s
        [form/secondary-button-s {:type "button"
                                  :on-click on-cancel} cancel-label]
        [form/button {:type "submit"} "Save"]]])))

(defn estate-and-tax [{:keys [on-edit]}]
  (let [sub (rf/subscribe [:profile/estate-and-tax])]
    (fn []
      (let [{:keys [attorney
                    successor] :as estate} (:estate @sub)
            {:keys [accountant
                    most-recent-return
                    tax-rate] :as tax} (:tax @sub)]

        [:section
         [common/profile-section-header {:link on-edit
                                         :text "Edit"
                                         :title "Estate & tax planning"}]
         (if (some some? (concat (vals estate) (vals tax)))
           [:div
            [common/data-row {:label "Attorney:"
                              :value attorney}]
            [common/data-row {:label "Successor trustee:"
                              :value successor}]
            [common/data-row {:label "Documents on file:"
                              :value (if (:documents-submitted estate) "Yes" "No")}]
            [common/divider-s]
            [common/data-row {:label "CPA:"
                              :value accountant}]
            [common/data-row {:label "Tax Rate:"
                              :value (when tax-rate (str tax-rate "%"))}]
            [common/data-row {:label "Most recent return:"
                              :value (to-local-time most-recent-return)}]
            [common/data-row {:label "Returns on file:"
                              :value (if (:documents-submitted tax) "Yes" "No")}]]
           [common/no-results
            {:text (long-str "The legacy you leave is a testament to the people and causes your care about most. "
                             "Together, let's minimize your tax burden and maximize the gift of your inheritence.")
             :button-text "Enter your estate & taxes"
             :button-click on-edit}])]))))
